var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Treeselect',{attrs:{"multiple":_vm.multiple,"options":_vm.mappedOptions,"value":_vm.valueIds,"placeholder":_vm.computedPlaceholder,"searchable":_vm.searchable,"clearable":false,"value-consists-of":"ALL_WITH_INDETERMINATE","sortValueBy":"INDEX"},on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"value-label",fn:function({ node }){return [_c('div',{staticClass:"chip-label",class:{
        parent: !node.raw.parentId,
        child: node.raw.parentId,
      }},[_vm._v(" "+_vm._s(node.label)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }